// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'compose.messageInput': 'Write message here...',
  'compose.sendButton': 'Send',
};
